<template>
    <div class="homePage">
        <input v-if="about" type="button" value="" @click="back" class="prevBtn">
        <transition name="fade" mode="out-in">

            <div v-if="isThanking" class="thanksContainer" key="aa">
                <div class="vectors"></div>
                <div class="brand"></div>
                <div class="titlePanel">
                    <div class="title">Thanks for taking 10. Your future self appreciates it.</div>
                </div>
            </div>

            <div v-else class="wakeMenu" key="ww">
                <div class="promptContainer">
                    <div class="promptBG">
                        <div class="circle"></div>
                    </div>
                    <transition name="fade" mode="out-in">
                        <div v-if="!about" key="a">
                            <div class="brand"></div>
                            <div class="prompt">
                                Welcome!<br>Been here before?
                            </div>
                        </div>
                        <div v-else key="b">
                            <div class="prompt aboutPrompt">Who wants to obsess<br>over their health? Not us!</div>
                            <div class="description">We use the power of science, data, and your own intuition to find the small things that you might be missing that could make a big difference to your well-being.</div>
                        </div>
                    </transition>
                </div>
                <div class="container">
                    <transition name="fade" mode="out-in">
                        <div v-if="!about" class="yesNo" key="c">
                            <router-link to="/login" class="btn yes" @click.native="click">Yep!</router-link>
                            <a class="btn no" @click="{about = true; click()}">Nope!</a>
                        </div>
                        <div v-else class="simpleSteps" key="d">
                            <div class="step">
                                <div class="num">1</div>
                                <div class="title">Take a Moment</div>
                                <div class="description">Imagine yourself on your very best day (2 min)</div>
                            </div>
                            <div class="step">
                                <div class="num">2</div>
                                <div class="title">Check in with yourself</div>
                                <div class="description">See how you’re doing today. (8 min)</div>
                            </div>
                            <div class="step">
                                <div class="num">3</div>
                                <div class="title">Take Charge</div>
                                <div class="description">Discover something new to try. (30 sec)</div>
                            </div>
                            <div class="step">
                                <div class="num">4</div>
                                <div class="title">Check in again</div>
                                <div class="description">Gain insight into your well-being over time.</div>
                            </div>
                            <input type="button" value="Let's Begin" @click="anonymousUser" class="beginBtn">
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import auth from '@/auth'
export default {
    name: 'HomePage',
    props: {},
    mixins: [],
    
    data() {
        return {
            isThanking: true,
            about: false,
        }
    },

    components: {
    },

    methods: {
        click() {
            this.$sound('type')
        },
        anonymousUser() {
            this.$sound('type')
            this.$sound('chime')
            auth.registerAnonymously().then((res) => {
                this.$router.replace('/form')
            }).catch((err) => {
                this.error = err.message
            });
        },
        back() {
            this.$sound('type')
            this.about = false
        }
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
        this.$animateLEDS("passive", "#000000")
        this.$nextTick(() => {
            let timeout = setTimeout(() => {
                this.isThanking = false
            }, 10000)
        })
    }

}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
.homePage {
    overflow: hidden;
    input.prevBtn {
        position: absolute;
        z-index: 1000;
        top: 8vw;
        left: 8vw;
        height: 10vw;
        width: 10vw;
        border-radius: 5vw;
        background-color: $color-darkCream;
        background-image: url(../assets/static/BackArrow.svg);
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: 40%;
    }
    .brand {
        position: relative;
        display: inline-block;
        width: 25vw;
        height: 10vw;
        background-image: url(../assets/static/brand.svg);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
    }
    .thanksContainer {
        padding: 8vw;
        text-align: center;
        .vectors {
            position: absolute;
            z-index: -1;
            top: 25vw;
            right: 2vw;
            left: 2vw;
            bottom: 0;
            background-image: url(../assets/static/collage.svg);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
        }
        
        .titlePanel {
            position: absolute;
            top: 50vh;
            left: 50vw;
            .title {
                width: 64vw;
                padding: 5vw;
                background: $color-white;
                margin-left: -50%;
                margin-top: -8vw;
                font-size: 5vw;
                border-radius: 2vw;
            }
        }
    }
    .wakeMenu {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100vh;
        background-color: $color-green;
        overflow: hidden;
    }
    .promptContainer {
        height: 30vh;
        text-align: center;
        padding-top: 30vw;
        .promptBG {
            position: absolute;
            left: 50vw;
            top: 40vh;
            .circle {
                z-index: -1;
                margin-left: -50%;
                margin-top: -100%;
                background: $color-cream;
                width: 220vw;
                height: 220vw;
                border-radius: 110vw;
                background-image: url(../assets/static/buttons.svg);
                background-repeat: no-repeat;
                background-position: 50% 86%;
                background-size: 46%;
            }
        }
        .prompt {
            position: relative;
            margin-top: 5vw;
            width: 100%;
            text-align: center;
        }
        .aboutPrompt {
            margin-top: -3vw;
        }
        .description {
            padding: 3vw 10vw;
            position: relative;
            font-size: 3vw;
            color: $color-dark;
            font-weight: 500;
            line-height: 1.5;
        }
    }
    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        
        .yesNo {
            width: 100%;
            text-align: center;
            margin-top: 10vw;
            margin-bottom: 10vw;
            a {
                display: inline-block;
                margin: 5vw;
                height: 30vw;
                width: 30vw;
                border-radius: 15vw;
                line-height: 30vw;
                font-size: 5.5vw;
            }
            .yes {
                color: $color-dark;
                background-color: $color-cream;
            }
            .no {
                color: $color-white;
                background-color: $color-dark;
            }
        }
        .simpleSteps {
            padding: 0 8vw;
            margin-top: -7.5vw;
            .step {
                height: 12vw;
                background: $color-cream;
                font-size: 3.5vw;
                padding: 1.5vw;
                border-radius: 9vw;
                margin: 3vw 0;
                .title {
                    margin-top: 1.5vw;
                    margin-bottom: .5vw;
                }
                .num {
                    height: 12vw;
                    float: left;
                    width: 12vw;
                    text-align: center;
                    line-height: 13.5vw;
                    border-radius: 7vw;
                    background: $color-darkCream;
                    font-size: 5vw;
                    margin-right: 3vw;
                    font-family: "Walsheim";
                    font-weight: 500;
                    opacity: .75;
                }
                .description {
                    font-size: 2.8vw;
                    font-weight: 500;
                }
            }
        }
    }
    .helperText {
        color: $color-dark;
        opacity: .5;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 7.5vh;
        text-align: center;
    }
    .beginBtn {
        height: 10vw;
        width: 50vw;
        background: $color-dark;
        border-radius: 5vw;
        color: $color-white;
        font-family: "Walsheim";
        font-weight: 700;
        font-size: 28px;
        letter-spacing: .3vw;
        text-transform: uppercase;
        padding-top: 8px;
        box-sizing: border-box;
        position: absolute;
        bottom: 5vh;
        left: 25vw;
    }
}

</style>